/**
 * cld-imprint-options.js
 * 名入れオプション固定データ（名入れ書体・パターン）
 *
 * 【名入れ色について】
 * 色データはShopify管理画面「コンテンツ → メタオブジェクト → 名入れ色」で管理する。
 * このファイルには色の定義を持たない。
 *
 * 【色の商品への紐付け】
 * 商品タグに `cld-color-<ハンドル>` を付けることで表示する色を指定する。
 * 例: ハンドル「black」の色を使いたい商品 → タグ「cld-color-black」を追加
 */
// パターン・書体画像はLiquid（cld-main-product.liquid）から asset_url で注入される
// 色データもLiquid（メタオブジェクト）から注入される。このファイルは fonts のフォールバック定義のみ管理する
var _savedPatterns = window.CLD_IMPRINT_OPTIONS && window.CLD_IMPRINT_OPTIONS.patterns;
var _savedFonts    = window.CLD_IMPRINT_OPTIONS && window.CLD_IMPRINT_OPTIONS.fonts;
var _savedColors   = window.CLD_IMPRINT_OPTIONS && window.CLD_IMPRINT_OPTIONS.colors;
window.CLD_IMPRINT_OPTIONS = {

  /* ── 名入れ色：Liquidがメタオブジェクトから設定済みの値を保持 ── */
  colors: _savedColors || [],

  /* ── 名入れ書体（Liquidから画像URL付きで上書きされる） ── */
  fonts: _savedFonts || [
    { id: 'mincho',      label: '明朝体' },
    { id: 'gothic',      label: 'ゴシック体' },
    { id: 'shin-gothic', label: '新ゴシック体' },
    { id: 'maru',        label: '丸ゴシック体' },
    { id: 'kaisho',      label: '楷書体' },
    { id: 'gyosho',      label: '行書体' },
    { id: 'reisho',      label: '隷書体' },
    { id: 'sougei',      label: '綜藝体' },
    { id: 'reiga',       label: '麗雅宋' },
    { id: 'pop',         label: 'ポップ体' },
    { id: 'kanteiryu',   label: '勘亭流' }
  ],

  /* ── 名入れパターン（Liquidから動的取得） ── */
  patterns: _savedPatterns || []

};
